<template>
    <div class="row">
        <kt-col lg="6" md="6" xs="12" class="pt-3 pr-3 pl-4">
            <form @submit.prevent="submit($event, query)" id="store_form">
                <kt-form-section is_first>
                    <kt-row>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-form-group class="overlay-form-group">
                                <kt-form-label for="fa_name" class="overlay-label">
                                    {{ $t('label.fa_name') }}
                                </kt-form-label>
                                <kt-form-control
                                        id="fa_name"
                                        name="fa_name"
                                        v-model="query.fa_name"
                                        class="overlay-input"
                                >
                                </kt-form-control>
                                <kt-form-text>
                                    <i class="fa fa-info-circle mt-1" aria-hidden="true" style="font-size: 1.1rem"></i>
                                    {{ $t('hint.store_fa_name') }}
                                </kt-form-text>
                            </kt-form-group>
                        </kt-col>

                        <kt-col lg="12" md="12" xs="12">
                            <kt-form-group class="overlay-form-group">
                                <kt-form-label for="en_name" class="overlay-label">
                                    {{ $t('label.en_name') }}
                                </kt-form-label>
                                <kt-form-control
                                        id="en_name"
                                        name="en_name"
                                        v-model="query.en_name"
                                        dir="ltr"
                                        class="overlay-input"
                                >
                                </kt-form-control>
                                <kt-form-text>
                                    <i class="fa fa-info-circle mt-1" aria-hidden="true" style="font-size: 1.1rem"></i>
                                    {{ $t('hint.store_en_name') }}
                                </kt-form-text>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-form-group class="overlay-form-group">
                                <kt-form-label for="phone_number" class="overlay-label">
                                    {{ $t('label.phone_number') }}
                                </kt-form-label>
                                <kt-form-control
                                        dir="ltr"
                                        id="phone_number"
                                        name="phone_number"
                                        v-model="query.phone_number"
                                        class="overlay-input"
                                >
                                </kt-form-control>
                                <kt-form-text>
                                    <i class="fa fa-info-circle mt-1" aria-hidden="true" style="font-size: 1.1rem"></i>
                                    {{ $t('hint.store_phone_number') }}
                                </kt-form-text>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                    <kt-row>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-form-group>
                                <kt-form-label for="gateway">
                                    {{ $t('label.connect_to_gateway') }}
                                </kt-form-label>

                                <label
                                        v-if="!has_active_gateway"
                                        for="default_gateway"
                                        class="gateway-label"
                                >
                                    <input
                                            type="radio"
                                            checked="checked"
                                            name="default_gateway"
                                            id="default_gateway"
                                            class="custom-radio-gateway"
                                    >
                                    <i class="fa fa-credit-card fa-lg" aria-hidden="true"></i>
                                    درگاه پیشفرض پی استار
                                </label>

                                <select
                                        v-if="active_gateways"
                                        id="gateway_id"
                                        name="gateway_id"
                                        v-model="query.gateway_id"
                                        class="form-control kt-selectpicker"
                                >
                                    <option value="0">{{ $t('label.default_gateway') }}</option>
                                    <option
                                            v-bind:key="gateway.id"
                                            v-for="gateway in active_gateways"

                                            :value="gateway.id"
                                    >
                                        {{ gateway.title }}
                                    </option>
                                </select>
                                <kt-form-text>
                                    <i class="fa fa-info-circle mt-1" aria-hidden="true" style="font-size: 1.1rem"></i>
                                    {{ $t('hint.store_gateway') }}
                                </kt-form-text>
                            </kt-form-group>
                        </kt-col>

                    </kt-row>
                </kt-form-section>

                <kt-form-section>
                    <kt-row>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="description">
                                    {{ $t('label.description') }}
                                </kt-form-label>
                                <kt-form-textarea
                                        id="description"
                                        name="description"
                                        v-model="query.description"
                                >
                                </kt-form-textarea>
                                <kt-form-text>
                                    <i class="fa fa-info-circle mt-1" aria-hidden="true" style="font-size: 1.1rem"></i>
                                    {{ $t('hint.store_callback_url') }}
                                </kt-form-text>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label>
                                    {{ $t('label.logo') }}
                                </kt-form-label>
                                <kt-form-label for="logo_file" class="d-block btn btn-secondary btn-wide label-file">
                                    <kt-icon type="fa" name="paperclip"></kt-icon>
                                    {{ $t('gateway.btn.click_me') }}
                                    <input
                                            @change="processLogoFile"
                                            type="file"
                                            hidden
                                            name="logo"
                                            id="logo_file"
                                            accept="image/*"
                                    />
                                </kt-form-label>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </kt-form-section>

                <kt-form-section>
                    <kt-row>

                    </kt-row>
                </kt-form-section>

                <kt-form-action class="mt-4">
                    <kt-button
                            class="m-2"
                            size="md"
                            variant="success"
                            type="submit"
                            v-bind:wide="true"
                            id="submit_btn"
                    >
                        {{ $t('panel.profile.update.wizard.form.btn.submit') }}
                    </kt-button>
                </kt-form-action>
            </form>
        </kt-col>
        <kt-col lg="6" md="6" xs="12"></kt-col>
    </div>
</template>

<script>
import { subcategories } from '@/constants/subcategories'
import $ from 'jquery'
import Inputmask from 'inputmask'
import { mapGetters, mapState } from 'vuex'
import { i18n } from '@/plugins/i18n'

export default {
    props: {
        submit: {
            default: () => {},
            type: Function
        },
        query: {
            default() {
                return {
                    gateway_id: 0
                }
            },
            type: Object
        }
    },
    data() {
        return {
            has_active_gateway: false
        }
    },
    mounted() {
        if(this.query.user_id) {
            this.$store.dispatch('gateway/fetchByUserId', this.query.user_id)
        }else {
            this.$store.dispatch('gateway/fetch')
        }
    },
    methods: {
        processLogoFile(e) {
            this.query.logo = event.target.files[0]
        },
    },
    computed: {
        ...mapGetters('gateway', [
            'active_gateways'
        ]),
    },
}
</script>

<style>
    .label-file {
        border: 1px solid #ccc;
        cursor: pointer;
        min-width: 200px;
        width: fit-content
    }
    .overlay-form-group {
        margin-top: 15px;
        margin-bottom: 1.2rem!important;
        position: relative;
    }
    .overlay-form-group .overlay-label {
        position: absolute;
        top: 0;
        right: 8px;
        transform: translate(0, -50%);
        background-color: white;
        padding: 0 4px;
    }
    .overlay-form-group .overlay-input {
        padding-top: 1.5rem;
        height: auto;
    }
    .gateway-label {
        display: block;
        width: fit-content;
        height: auto;
        padding: 10px;
        border: 1px solid #ccc;
        border-radius: 4px;
    }
    .custom-radio-gateway {
        margin-left: 12px;
    }
</style>